export const guidEmpty = (): string => {
    return '00000000-0000-0000-0000-000000000000'
}